import React, { FC } from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { format } from 'date-fns';

import { ProjectCommunication } from '../../model';

interface ProjectCommunicationDetailsProps {
  communication: ProjectCommunication;
  showStatusChip?: boolean;
}

const ProjectCommunicationDetails: FC<ProjectCommunicationDetailsProps> = ({
  communication,
  showStatusChip = true,
}) => {
  return (
    <Box>
      {showStatusChip && (
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
          <Chip
            label={communication.status || 'N/A'}
            color={communication.has_status ? 'success' : 'default'}
            size="small"
          />
          <Chip
            label={communication.db_location === 'pittsburgh' ? 'PGH' : 'TPA'}
            color={communication.db_location === 'pittsburgh' ? 'primary' : 'secondary'}
            size="small"
          />
        </Box>
      )}

      <Box sx={{ mb: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Communication Summary
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Customer:</strong> {communication.customer || '-'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Job:</strong> {communication.job || '-'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Department:</strong> {communication.department || '-'} | <strong>Salesperson:</strong>{' '}
          {communication.salesperson || '-'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Opened:</strong> {communication.opened ? format(new Date(communication.opened), 'MM/dd/yyyy') : '-'} |{' '}
          <strong>Age:</strong> {communication.age} days
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Last Scheduled:</strong>{' '}
          {communication.last_scheduled ? format(new Date(communication.last_scheduled), 'MM/dd/yyyy') : '-'} |{' '}
          <strong>Last Communication:</strong>{' '}
          {communication.last_communication ? format(new Date(communication.last_communication), 'MM/dd/yyyy') : '-'}
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          <strong>Contact:</strong> {communication.who || '-'}
        </Typography>
        {communication.description && (
          <>
            <Typography variant="body2" sx={{ mb: 1, mt: 2 }}>
              <strong>Description:</strong>
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, pl: 2, fontStyle: 'italic' }}>
              {communication.description}
            </Typography>
          </>
        )}
        {communication.notes && (
          <>
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Notes:</strong>
            </Typography>
            <Typography variant="body2" sx={{ pl: 2, fontStyle: 'italic' }}>
              {communication.notes}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default ProjectCommunicationDetails;
